import axios from "axios";
import apiIndex from "~/api/index";
import { API_URL } from "~/env";
import { axiosConfig } from "~/utils/axios-utils";

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 60000,
});

const configuredAxios = axiosConfig(axiosInstance);

const req = apiIndex(configuredAxios);

/**
 * 不会处理需要登录的接口
 */
export default defineNuxtPlugin({
  name: "req-plugin",
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.provide("req", req);
  },
});

declare module "nuxt/app" {
  interface NuxtApp {
    $req: ReturnType<typeof apiIndex>;
  }
}

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $req: ReturnType<typeof apiIndex>;
  }
}
